/**
 * Cart popup autohandler.
 *
 * Usage:
 *
 *  data-sw-cart
 */

var $ = require('./../sw-jquery');
var Cart = require('./../../lib/views/Cart');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-cart]').each(function() {
    var $el = $(this);

    new Cart({
      el: $el
    });
  });

};
